<h2>Products</h2>

<div *ngFor="let product of products; index as productId">
	<h3>
		<a [title]="product.name +' details'" [routerLink]="['/products', productId]"> {{product.name}}
		</a>
	</h3>
	<p *ngIf="product.description">
		{{ product.description }}
	</p>
	<button (click)="share(product.name)">Share</button>
	<app-product-alert [product]="product" (notify)="onNotify(product)"></app-product-alert>
</div>
<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
-->